export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6312.313d5bf1.jpg";